<ng-container *ngIf="open">
    <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header p-0 " style="padding: 0px;">
              <h4 class="modal-title price-section-title" translate id="gridSystemModalLabel">
                <ng-container *ngIf="pricingsection;else mergeheadersection">
                  {{title}}
              </ng-container>
              <ng-template #mergeheadersection>
                  <span style="color: #3883C1;">{{title}}</span> > <span>Merge pricing records</span>
              </ng-template>
              </h4>
          </div>
          <div class="modal-body " [ngClass]="pricingsection ? 'modal-top-align':'merge-modal-top-align'">
            <div class="body-message" >
                <div *ngIf="loading">
                    <div class="loading-wrap">
                        <span class="circle1"></span>
                        <span class="circle2"></span>
                        <span class="circle3"></span>
                        <p class="loading-text">
                            Loading line items...
                        </p>
                    </div>
                </div>
                <div class="mth-5 padding-fifteen" *ngIf="!loading && !isPricingItemsAvailable">
                    <div class="no-results-wrap">
                        <div class="warning-icon-wrap with-info-icon">
                            <span class="ss-info icon fix-left">&nbsp;</span>
                        </div>
                        <!--<div class="warning-message" translate>No.pricing.items.added.yet</div> Some reason its not getting updated need to check-->
                        <div class="warning-message">No pricing item available to add</div>
                    </div>
                </div>
            <ng-container *ngIf="pricingsection;else mergebodysection">
              <div class="display-all sticky-content" [hidden]="!isPricingItemsAvailable || loading">
                  <div class="dropdown-section-border">
                      <select class="select-width-100"
                              (change)="chooseType($event.target.value)">
                          <option value="display_all"  translate>Display.all.labour.parts.and.expenses</option>
                          <option value="supply" translate>Supply and fit</option>
                      </select>
                  </div>
                  <div id="showsearch" class="row-fluid search-section-padding">
                       <div class="search-box-container">
                          <div class="search-box">
                                <span style="padding: 0px 2px 10px 8px; height: 16px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                         fill="none">
                                        <path
                                            d="M13.8067 12.86L11.54 10.6C12.2713 9.66831 12.6681 8.51777 12.6667 7.33334C12.6667 6.2785 12.3539 5.24736 11.7678 4.37029C11.1818 3.49323 10.3489 2.80965 9.37431 2.40598C8.39978 2.00231 7.32742 1.89669 6.29285 2.10248C5.25829 2.30827 4.30798 2.81622 3.5621 3.5621C2.81622 4.30798 2.30827 5.25829 2.10248 6.29285C1.89669 7.32742 2.00231 8.39978 2.40598 9.37431C2.80965 10.3489 3.49323 11.1818 4.37029 11.7678C5.24736 12.3539 6.2785 12.6667 7.33334 12.6667C8.51777 12.6681 9.66831 12.2713 10.6 11.54L12.86 13.8067C12.922 13.8692 12.9957 13.9188 13.077 13.9526C13.1582 13.9864 13.2453 14.0039 13.3333 14.0039C13.4213 14.0039 13.5085 13.9864 13.5897 13.9526C13.671 13.9188 13.7447 13.8692 13.8067 13.8067C13.8692 13.7447 13.9188 13.671 13.9526 13.5897C13.9864 13.5085 14.0039 13.4213 14.0039 13.3333C14.0039 13.2453 13.9864 13.1582 13.9526 13.077C13.9188 12.9957 13.8692 12.922 13.8067 12.86ZM3.33334 7.33334C3.33334 6.54221 3.56793 5.76885 4.00746 5.11106C4.44698 4.45326 5.0717 3.94057 5.8026 3.63782C6.53351 3.33507 7.33777 3.25585 8.1137 3.41019C8.88962 3.56454 9.60235 3.9455 10.1618 4.50491C10.7212 5.06432 11.1021 5.77705 11.2565 6.55297C11.4108 7.3289 11.3316 8.13317 11.0289 8.86407C10.7261 9.59497 10.2134 10.2197 9.55562 10.6592C8.89782 11.0987 8.12446 11.3333 7.33334 11.3333C6.27247 11.3333 5.25505 10.9119 4.50491 10.1618C3.75476 9.41162 3.33334 8.3942 3.33334 7.33334Z"
                                            fill="#8E8E8E" />
                                    </svg>
                                </span>
                              <input id="search" class="search-input-box-align" placeholder="Search" (keyup)="onSearch($event,'inline')" value="" type="search">
                          </div>
                      </div>
                    <!--  <div class="span12">
                          <div class="app-filter search-with-tabs customer-history-search mb-1">
                              <div class="search_box small">
                                  <i class="fas fa-search search-icon pricing-section-search-icon"></i>
                                  <input id="search" placeholder="Search" (keyup)="onSearch($event,'inline')" value="" type="search">
                              </div>
                              <div class="select_all">
                                  <div id="select-all" class="checkbox-all"><input type="checkbox" [checked]="selectAllTop" (change)="handleSelect($event, 'all')"></div>
                                  <span class="select-text" translate>Select all</span>
                              </div>
                          </div>
                      </div>-->
                  </div>
              </div>
              <div class="list-items list-items-alignment" [hidden]="loading">
                  <div class="mth-5 padding-fifteen" *ngIf="isSearching && (typeChoosed=='display_all' && !filteredlabouritems.length && !filteredpartsitems.length && !filteredexpensesitems.length)
                  || (typeChoosed=='supply' && (!filteredsupplyfititems.length || !supplyFititems.length))">
                      <div class="no-results-wrap">
                          <div class="warning-icon-wrap with-info-icon">
                              <span class="ss-info icon fix-left">&nbsp;</span>
                          </div>
                          <!--<div class="warning-message" translate>No.pricing.items.added.yet</div> Some reason its not getting updated need to check-->
                          <div class="warning-message">No pricing items found for this search</div>
                      </div>
                  </div>
                  <ng-container *ngIf="typeChoosed !='supply'">
                      <div class="opp-finance-section" *ngIf="filteredlabouritems.length">
                      <div class="bold mth-5 mb-1 mt-0 font-size-alignment checkbox-display-center" translate *ngIf="filteredlabouritems.length">
                          <div class="opp-item-header">
                              <span class="text" translate>Labour</span>
                          </div>
                          <div class="right-side-align-select-all">
                              <div class="custom_checkbox">
                                  <input type="checkbox" [checked]="selectAllLabour" id="labour-select-all" (change)="handleSelect($event, 'labour')" >
                                  <label for="labour-select-all" >Select all</label>
                              </div>
                          </div>
                      </div>
                      <ng-container *ngFor="let items of filteredlabouritems;let l=index">
                          <div class="list-item-parts" (click)="selectPrices($event, 'labour', items, l)">
                              <div class="input-section">
                                  <div class="custom_checkbox">
                                      <input type="checkbox" [checked]="items.selected" id="{{'labouritem' + l}}" >
                                      <label for="{{'labour' + l}}" > {{items.description}} </label>
                                  </div>
                              </div>
                              <div class="checkbox-all" id="{{'labour' + l}}">
                                  <div class="price-and-vat-section">
                                      <span class="total-margin-right-align">{{items.totalSalePrice | currency}}</span>
                                      <ng-container *ngIf="vatEnabled">
                                          <span  class="center-of-line">|</span> <span class="total-margin-left-align">{{items.tax}}% {{taxLabel}}</span>
                                      </ng-container>
                                  </div>
                              </div>
                          </div>
                      </ng-container>
                      </div>
                  </ng-container>
                  <ng-container *ngIf="typeChoosed=='display_all'">
                      <div class="opp-finance-section" *ngIf="filteredpartsitems.length">
                      <div class="bold mth-5 mb-1 mt-0 font-size-alignment checkbox-display-center" translate *ngIf="filteredpartsitems.length">
                          <div class="opp-item-header">
                              <span class="text" translate>Parts</span>
                          </div>
                          <div class="right-side-align-select-all">
                              <div class="custom_checkbox">
                                  <input type="checkbox" [checked]="selectAllParts" id="parst-select-all" (change)="handleSelect($event, 'parts')" >
                                  <label for="parst-select-all" >Select all</label>
                              </div>
                          </div>
                      </div>
                      <ng-container *ngFor="let items of filteredpartsitems;let p=index">
                          <div class="list-item-parts" (click)="selectPrices($event, 'parts',items, p)">
                              <div class="input-section">
                                  <div class="custom_checkbox">
                                      <input type="checkbox" [checked]="items.selected" id="{{'partsitem' + p}}" >
                                      <label for="{{'parts' + p}}" > {{items.description}} </label>
                                  </div>
                              </div>
                              <div class="checkbox-all" id="{{'parts' + p}}">
                                  <div class="price-and-vat-section" *ngIf="tableType == 'opportunity'">
                                      <span class="total-margin-right-align">{{items.totalSalePrice | currency}}</span>
                                      <ng-container *ngIf="vatEnabled">
                                          <span  class="center-of-line">|</span> <span class="total-margin-left-align">{{items.tax}}% {{taxLabel}}</span>
                                      </ng-container>
                                  </div>
                                  <div class="price-and-vat-section" *ngIf="tableType != 'opportunity'">
                                      <span class="total-margin-right-align">N/A</span>
                                      <ng-container *ngIf="vatEnabled">
                                          <span  class="center-of-line">|</span> <span class="total-margin-left-align">{{items.tax}}% {{taxLabel}}</span>
                                      </ng-container>
                                  </div>
                              </div>
                          </div>
                      </ng-container>
                      </div>
                  </ng-container>
                  <ng-container *ngIf="typeChoosed=='supply'">
                      <div class="opp-finance-section" *ngIf="filteredsupplyfititems.length">
                      <div class="bold mth-5 mb-1 mt-0 font-size-alignment checkbox-display-center" translate *ngIf="filteredsupplyfititems.length">
                          <div class="opp-item-header">
                              <span class="text" translate>Supply and fit</span>
                          </div>
                          <div class="right-side-align-select-all">
                              <div class="custom_checkbox">
                                  <input type="checkbox" [checked]="selectAllSupplyAndFit" id="supply-fit-select-all" (change)="handleSelect($event, 'supply')" >
                                  <label for="supply-fit-select-all" >Select all</label>
                              </div>
                          </div>
                      </div>
                      <ng-container *ngFor="let items of filteredsupplyfititems;let s=index">
                          <div class="list-item-parts" (click)="selectPrices($event, 'supply', items, s)">
                              <div class="input-section">
                                  <div class="custom_checkbox">
                                      <input type="checkbox" [checked]="items.selected" id="{{'supplyitem' + s}}" >
                                      <label for="{{'supply' + s}}" >{{items.description}}</label>
                                  </div>
                              </div>
                              <div class="checkbox-all" id="{{'supply' + s}}">
                                  <div class="price-and-vat-section" *ngIf="tableType == 'opportunity' || (tableType != 'opportunity' && items.partCostId == 0)">
                                      <span class="total-margin-right-align">{{items.totalSalePrice | currency}}</span>
                                      <ng-container *ngIf="vatEnabled">
                                          <span  class="center-of-line">|</span> <span class="total-margin-left-align">{{items.tax}}% {{taxLabel}}</span>
                                      </ng-container>
                                  </div>
                                  <div class="price-and-vat-section" *ngIf="tableType != 'opportunity' && items.partCostId != 0">
                                      <span class="total-margin-right-align">N/A</span>
                                      <ng-container *ngIf="vatEnabled">
                                          <span  class="center-of-line">|</span> <span class="total-margin-left-align">{{items.tax}}% {{taxLabel}}</span>
                                      </ng-container>
                                  </div>
                              </div>
                          </div>
                      </ng-container>
                      </div>
                  </ng-container>
                  <ng-container *ngIf="typeChoosed!='supply'">
                      <div class="opp-finance-section" *ngIf="filteredexpensesitems.length">
                      <div class="bold mth-5 mb-1 mt-0 font-size-alignment checkbox-display-center" translate *ngIf="filteredexpensesitems.length">
                          <div class="opp-item-header">
                              <span class="text" translate>Expenses</span>
                          </div>
                          <div class="right-side-align-select-all">
                              <div class="custom_checkbox">
                                  <input type="checkbox" [checked]="selectAllExpenses" id="expenses-select-all" (change)="handleSelect($event, 'expenses')" >
                                  <label for="expenses-select-all" >Select all</label>
                              </div>
                          </div>
                      </div>
                      <ng-container *ngFor="let items of filteredexpensesitems;let e=index">
                          <div class="list-item-parts" (click)="selectPrices($event,'expenses',items, e )">
                              <div class="input-section">
                                  <div class="custom_checkbox">
                                      <input type="checkbox" [checked]="items.selected" id="{{'expensesitem' + e}}" >
                                      <label for="{{'expenses' + e}}" > {{items.description}} </label>
                                  </div>
                              </div>
                              <div class="checkbox-all" id="{{'expenses' + e}}">
                                  <div class="price-and-vat-section">
                                      <span class="total-margin-right-align">{{items.totalSalePrice | currency}}</span>
                                      <ng-container *ngIf="vatEnabled">
                                          <span  class="center-of-line">|</span> <span class="total-margin-left-align">{{items.tax}}% {{taxLabel}}</span>
                                      </ng-container>
                                  </div>
                              </div>
                          </div>
                      </ng-container>
                      </div>
                  </ng-container>
              </div>
          </ng-container>
          <ng-template #mergebodysection>
            <div class="row-fluid pad-15">
                <div class="span12">
                    <div class="control-group clearfix">
                        <label class="control-label required_field" translate>Description.of.pricing.item</label>
                        <div class="controls" [formGroup]="mergeForm">
                            <input type="text" class="control-input" formControlName="description" autofocus>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
            </div>
          </div>
          <div class="modal-footer">
            <ng-container *ngIf="pricingsection;else mergefootersection">
              <a href="javascript:void(0)" class="btn" (click)="bsModalRef.hide()">Cancel</a>
              <button *ngIf="typeChoosed!='supply'" [disabled]="mergeEnable" class="btn btn-primary" (click)="mergeSave();">
                  <span translate>Merge.and.save</span>
              </button>
              <button [disabled]="submitEnable" class="btn btn-primary" (click)="savePricing()">
                  <span translate>Save</span>
              </button>
          </ng-container>
          <ng-template #mergefootersection>
              <a href="javascript:void(0)" class="btn" (click)="mergeCancel()">Cancel</a>
              <button [disabled]="!mergeForm.valid" class="btn btn-primary" (click)="mergePricingRecords()">
                  <span translate>Save</span>
              </button>
          </ng-template>
          </div>
        </div>
      </div>
</ng-container>
